module.exports = __webpack_public_path__ + "img/MEDIA097.d4caba52.jpg";